/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_IgnoreInputs */

const vi_expense_sync_ignore = /** @type {(inputs: Expense_Sync_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua`)
};

/**

* @param {Expense_Sync_IgnoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_ignore = /** @type {((inputs?: Expense_Sync_IgnoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_IgnoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_ignore(inputs)
});